define('lq/events/actions/executeQuery',[
    'underscore',
    'lq/events/actions/eventAction',
    'lq/asyncSubcriptions'
], function (_, EventAction, asyncSubcriptions) {
    'use strict';

    function ExecuteQuery(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(ExecuteQuery, EventAction);

    ExecuteQuery.typeName = 'ExecuteQuery';

    ExecuteQuery.prototype.getBatchType = function () {
        return !this.eventData.dataSource.async || this.eventData.dataSource.initialDataSource
            ? EventAction.QUERY_BATCH
            : EventAction.DO_NOT_BATCH;
    };

    ExecuteQuery.prototype.createEventActionRequest = function () {
        if (this.getBatchType() === EventAction.DO_NOT_BATCH)
            return undefined;

        var queriesBatch = [];
        var listeners = this.piping.datasources.getDatasourceListenersThatListenFor(this.eventData.dataSource.id);
        _.each(listeners, function (listener) {
            var params = {};

            if (typeof (listener.decorateDataFunc) === "function") {
                listener.decorateDataFunc(params);
            }

            var queryWithTheSameParams = _.find(queriesBatch, function (q) {
                return _.isEqual(q.params, params);
            });
            if (queryWithTheSameParams) {
                queryWithTheSameParams.listeners.push(listener.id);
            } else {
                queriesBatch.push({
                    listeners: [ listener.id ],
                    params: params
                });
            }
        });

        if (queriesBatch.length > 0) {
            return {
                eventActionType: "ExecuteQuery",
                actionId: this.piping.actionId,
                rootMorphId: this.eventData.dataSource.rootMorphId,
                queryObjectName: this.eventData.dataSource.id,
                queries: queriesBatch
            };
        } else {
            return undefined; //no request needed because there are no listeners for this query!
        }
    };

    ExecuteQuery.prototype.execute = function (continuation, eventActionResponse) {
        if (eventActionResponse) {
            var self = this;
            _.each(eventActionResponse.Results, function (result) {
                _.each(result.Listeners, function(listenerId) {
                    var listener = self.piping.datasources.getDatasourceListener(listenerId);
                    listener.handler(result.Result, false);
                });
            });
        }

        if (this.eventData.dataSource.async) {
            asyncSubcriptions
                .addDatasourceSubscription(
                    this.piping,
                    this.eventData.dataSource.id,
                    this.eventData.dataSource.filter,
                    this.receiveAsyncData.bind(this))
                .then(continuation);
        } else {
            continuation();
        }
    };

    ExecuteQuery.prototype.receiveAsyncData = function (results) {
        var listeners = this.piping.datasources.getDatasourceListenersThatListenFor(this.eventData.dataSource.id);

        _.each(listeners, function (listener) {
            listener.handler(results, true);
        });

    };

    return ExecuteQuery;
});
